import React from 'react';
import ReactDOM from 'react-dom';
import {HashRouter as Router} from 'react-router-dom';
// import Caliper from '@learninganalytics/caliperjs';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import Sdk from 'api.digitalpages.module.sdk.api';
import Offliner from './hooks/offliner';

var Caliper = {}

function setupCalliper(project) {
  var caliperConnector = project.connectors.find(connector => connector.type === "CalyperAnalytics_1");

  if (caliperConnector) {
    Caliper.init({
      clientId: caliperConnector.configuration.client_id,
      host: caliperConnector.configuration.host,
      appId: caliperConnector.configuration.app_id,
      sensorId: caliperConnector.configuration.sensor_id
    });
  }
}

function setOnline(status) {
  if (navigator.onLine === true) document.body.classList.remove("offline");
  if (navigator.onLine === false) document.body.classList.add("offline");
};

function start() {
  // document.body.classList.add("offline");
  setOnline(navigator.onLine)
  window.addEventListener('online',  () => setOnline(true));
  window.addEventListener('offline', () => setOnline(false));

  if (localStorage.getItem("iammobile") === "true") {
    document.addEventListener("deviceready", function () {
      setup()
    });
  } else {
    setup()
  }
}

function setup() {
  var _this = this;
  Sdk.Api.request.Request.onMobile = Offliner.inApp();
  // if (window.localStorage.getItem("active-project") !== null) Sdk.authorization.setActiveProject(window.localStorage.getItem("active-project"))
  Sdk.Api.request.Request.handleError = async function(response) {
    if (response && response.status) {
      const { credential } = Sdk.Api.authorization;

      let currentTimestamp = new Date().getTime()/1000;
      if (credential && !/(2)[0-9][0-9]/g.test(response.status) && credential.expire && currentTimestamp > credential.expire) {
        window.dispatchEvent(new Event("@rdpplayer.event(logout)"));
      }
    }
  };
  ReactDOM.render(<Router><App/></Router>, document.getElementById('root'));
}

const setActiveProject = async (apiContext) => {
  try {
    // const projectHostConfig = await getProjectUidByHost();
    var projectHostConfig = null;
    let projectUid = null;

    if (projectHostConfig) {
      projectUid = projectHostConfig.project_uid;
    } else {
      const response = await fetch("./api_context.json");
      const config = await response.json();
      projectUid = config.project_uid;
    }

    // try {
    //   var projectByDomainRequest = await fetch(`${Sdk.Api.domain}/auth/v1.0/project/domain/${window.location.host}`, {
    //     "headers": {
    //       "api-env": Sdk.Api.enviroment,
    //       "project-key": Sdk.Api.projectKey,
    //     },
    //     "method": "GET"
    //   });
    //   var projectByDomainResponse = await projectByDomainRequest.json();
  
    //   projectUid = projectByDomainResponse.uid;
    // } catch (e) {
    //   console.log(e)
    // }

    var project = await Sdk.dynamic.bridgeUrl(`auth/v1.0/project/uid/${projectUid}`);
    await Sdk.initializeFromProject(projectUid, "DirectRegister_1");
    
    await Sdk.authorization.setActiveProject(project);
    setupCalliper(project);


  } catch (e) {
    console.error(e)
  }
}

async function preStart() {
  var authLocal = null;
  for (var i = 0, len = window.localStorage.length; i < len; ++i ) {
    if (window.localStorage.key(i).search("authorization-project-") > -1) {
      authLocal = localStorage.key(i);
    };
  };
  if (authLocal) {
    var obj = JSON.parse(window.localStorage.getItem(authLocal));
    var timestampInMiliseconds = new Date().getTime()
    var formattedTimestamp = timestampInMiliseconds / 1000;
    if (obj.credential) {
      if (formattedTimestamp > obj.credential.expire) {
        window.localStorage.removeItem(authLocal);
        window.localStorage.removeItem("authorization-key-48cfdc30c42d45bbbd3389c9f90cb108-production'");
      }
    }
  };

  const response = await fetch("./api_context.json");
  const config = await response.json();
  
  // console.log("Config carregado:", config);
  // console.log("project_uid:", config.project_uid);
  
  // console.log(config)
  Sdk.setProjectKey(config.project_key);
  Sdk.setEnviroment(config.api_env);
  Sdk.authorization.shareSession = true;

  if (config.domain !== undefined) 
  {
    var protocol = window.location.protocol;
    if (protocol.indexOf("http") > -1) protocol = "https:"

    Sdk.Api.domain = `${protocol}//` + config.domain;
    //todo:corrigir sdk
    Sdk.Api.authorization.domain = Sdk.Api.domain;
    Sdk.Api.directRegister.domain = Sdk.Api.domain;
    Sdk.Api.storage.domain = Sdk.Api.domain;
    Sdk.Api.store.domain = Sdk.Api.domain;
    Sdk.Api.insights.domain = Sdk.Api.domain;
    Sdk.Api.cms.domain = Sdk.Api.domain;
    Sdk.Api.iot.domain = Sdk.Api.domain;
    Sdk.Api.dynamic.domain = Sdk.Api.domain;
    Sdk.Api.dam.domain = Sdk.Api.domain;
    Sdk.Api.guide.domain = Sdk.Api.domain;
  }

  // Inicializar SDK básico sem projeto específico
  await Sdk.initialize({"initializeConnectors": true});
  
  start();
}

if (["http:", "https:", "app:"].includes(window.location.protocol) || window.location.hostname === "localhost") {
  preStart();
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
